// Small pixel-grid helpers for the info pages, ported from the prototypes'
// inline canvases. Self-contained (inline grid) so they don't depend on theme
// classes.

export function Grid8({
  rows,
  palette,
  size,
}: {
  rows: string[];
  palette: (string | null)[];
  size: number;
}) {
  const cells: JSX.Element[] = [];
  rows.forEach((row, y) => {
    for (let x = 0; x < 8; x++) {
      const ch = row[x] ?? ' ';
      const bg = ch === ' ' || ch === '.' ? undefined : palette[Number(ch)] ?? undefined;
      cells.push(<i key={`${y}-${x}`} style={bg ? { background: bg } : undefined} />);
    }
  });
  return (
    <span
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(8,1fr)',
        gridTemplateRows: 'repeat(8,1fr)',
        width: size,
        height: size,
      }}
    >
      {cells}
    </span>
  );
}

// The neon title "ball" (design/what-is-this.html).
export const BALL_ROWS = [
  '00111100',
  '02431420',
  '14314214',
  '13142431',
  '12431421',
  '14214314',
  '03142140',
  '00111100',
];
export const BALL_PAL = [null, '#ff2e88', '#4d6bff', '#ffb020', '#ffe9f7'];

// Three style-card icons.
export const ICON_PRISON = ['10101010', '10101010', '10101010', '11111111', '10101010', '10101010', '10101010', '10101010'];
export const PAL_PRISON = ['#0d1310', '#2b3a2c', '#6d7f68', '#a9bda2'];
export const ICON_ABC = ['  0110  ', ' 024310 ', '03142140', '14231342', '24314213', '13142431', ' 032410 ', '  0110  '];
export const PAL_ABC = ['#3a1069', '#ff2e88', '#4d6bff', '#ffb020', '#ffe9f7'];
export const ICON_SIMPLE = ['00000000', '01011110', '01101110', '01111110', '01101110', '01011110', '00000000', '01111110'];
export const PAL_SIMPLE = ['#e8e8e8', '#101010', '#9c9c9c', '#4d4d4d'];

// Media-type glyphs for the round-types table.
export const MEDIA_ROWS: Record<'audio' | 'image' | 'video', string[]> = {
  audio: ['...11...', '...111..', '...1.11.', '...1..1.', '..11....', '.111....', '..11....', '........'],
  image: ['11111111', '1......1', '1..11..1', '1.1111.1', '111111.1', '1......1', '11111111', '........'],
  video: ['..1..1..', '...11...', '11111111', '1......1', '1.1111.1', '1......1', '11111111', '..1..1..'],
};
export const PAL_INK = [null, '#101010'];

// The demo profile face used in the "YOU" strip.
export const DEMO_FACE = [
  '............',
  '...111111...',
  '..11111111..',
  '..13333331..',
  '..11311311..',
  '..13333331..',
  '..13222231..',
  '..13222231..',
  '...133331...',
  '....1111....',
  '..11333311..',
  '.1313131313.',
];
